export const PATH_INDEX = '/';
export const PATH_FOUNDS = '/Funds/:address';

export const LINK_PATH_HOME = 'https://bishares.finance/';
export const LINK_PATH_ABOUT = 'https://bishares.finance/about-us';
export const LINK_PATH_FUNDS = 'https://bishares.finance/funds';
